import { render, staticRenderFns } from "./TicketsItemCreate.vue?vue&type=template&id=40976354&"
import script from "./TicketsItemCreate.vue?vue&type=script&lang=js&"
export * from "./TicketsItemCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports